export var VehicleType;
(function (VehicleType) {
    VehicleType["PASSENGER_CAR"] = "PASSENGER_CAR";
    VehicleType["MOTORCYCLE"] = "MOTORCYCLE";
    VehicleType["UNKNOWN"] = "UNKNOWN";
})(VehicleType || (VehicleType = {}));
//# sourceMappingURL=vehicleType.js.map